function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M300.95 55.172C-70.224 541.234-107.251 1401.01 241.214 2037.13c20.028 36.56 42.719 70.87 67.786 102.83h1339V0H347.353a768.967 768.967 0 00-46.403 55.172z",
  fill: "currentColor"
});

function SvgSquared(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1648 2139",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTY0OCAyMTM5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxwYXRoIGQ9Ik0zMDAuOTUgNTUuMTcyQy03MC4yMjQgNTQxLjIzNC0xMDcuMjUxIDE0MDEuMDEgMjQxLjIxNCAyMDM3LjEzYzIwLjAyOCAzNi41NiA0Mi43MTkgNzAuODcgNjcuNzg2IDEwMi44M2gxMzM5VjBIMzQ3LjM1M2E3NjguOTY3IDc2OC45NjcgMCAwMC00Ni40MDMgNTUuMTcyeiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPg==";
export { SvgSquared as ReactComponent };